import { useEffect, useRef, useState } from 'react'

/**
 * Scale a fixed-size design to the width of its container, like a screenshot.
 * Returns the container ref and the current scale factor (≤ 1).
 */
export function useFitScale(designWidth: number) {
  const ref = useRef<HTMLDivElement>(null)
  const [scale, setScale] = useState(1)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const update = () => setScale(Math.min(1, el.clientWidth / designWidth))
    update()
    const ro = new ResizeObserver(update)
    ro.observe(el)
    return () => ro.disconnect()
  }, [designWidth])

  return { ref, scale }
}
